import './App.css';
import React from 'react';
import NavBar from './components/navbar/navbar';
import { Container, CssBaseline, ThemeProvider } from '@mui/material';
import defaultTheme from './themes/default-theme';
import Disclaimer from './components/disclaimer/desclaimer';
import WSRODashboardProps from './assets/props/wsro-props';
import { ReactKeycloakProvider } from '@react-keycloak/web'
import { KeyCloakClient, KeyCloakProviderConfig } from './keycloak/keycloak-client';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignUp from './pages/signup/signup.page';
import { routes as appRoutes } from "./config/router";
class App extends React.Component {

  render() {

    return (
      // <ReactKeycloakProvider
      //   authClient={KeyCloakClient}
      //   initOptions={KeyCloakProviderConfig}
      //   onEvent={onKeyCloakEvent}
      //   onTokens={onKeyCloakTokens}
      // >
        <ThemeProvider theme={defaultTheme} >
          <CssBaseline />
          {/* <NavBar props={WSRODashboardProps.navbar} /> */}
          <Router>
              <Routes>
                {appRoutes.map((route) => (
                  <Route
                    key={route.key}
                    path={route.path}
                    element={<route.component />}
                  />
                ))}
              </Routes>
          </Router>

          {/* <Disclaimer props={WSRODashboardProps.disclaimerProps} /> */}
          {/* <div id='wsro-dashboard' style={{ border: 'none', width: '100%', height: '91vh' }}></div> */}
          {/* <iframe id="qLikIFrame" src={'https://dashboard-dev.cremedatafoundry.com/sense/app/efd73c80-b9e7-45a0-bb7f-5f16e15106b9/sheet/43f497ab-3285-46db-a87e-778fa60a4978/state/analysis'} style={{ border: 'none', width: '100%', height: '91vh' }}></iframe> */}
        </ThemeProvider>
      // </ReactKeycloakProvider>
    );
  }
}

export default App;
